import { Box, Grid, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { usePlanningStore } from '@tom-ui/planning'
import { useMinimalsTheme } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { CraneQueueStats } from './widgets/CraneQueueStats'
import { EquipmentStats } from './widgets/EquipmentStats'
import { RailVisitWidget } from './widgets/RailVisitWidget'
import { TruckVisitWidget } from './widgets/TruckVisitWidget'
import { VesselVisitWidget } from './widgets/VesselVisitWidget'

export const Dashboard = observer(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const { visitListViewStore } = usePlanningStore()

  const [currentDate] = useState(new Date())

  useEffect(() => {
    visitListViewStore.loadCurrentPage()
  }, [visitListViewStore])

  return (
    <Box sx={{ backgroundColor: theme.palette.grey[200], minHeight: '100%' }}>
      <Helmet>
        <title>{t('dashboard', 'Dashboard')}</title>
      </Helmet>
      <Stack p={1} px={2}>
        <Typography variant='h2'>
          {t('terminalOperationOverview', 'Terminal Operation Overview')}
        </Typography>
        <Typography variant='h4'>
          {`${t('today', 'Today')} ${dayjs().format('DD.MM.YYYY')}`}
        </Typography>
      </Stack>
      <Grid container spacing={2} p={2}>
        <Grid
          size={{
            xs: 12,
            lg: 4,
          }}
        >
          <VesselVisitWidget currentDate={currentDate} />
        </Grid>
        <Grid
          size={{
            xs: 12,
            lg: 4,
          }}
        >
          <RailVisitWidget currentDate={currentDate} />
        </Grid>
        <Grid
          size={{
            xs: 12,
            lg: 4,
          }}
        >
          <TruckVisitWidget />
        </Grid>
        <Grid size={12}>
          <Typography variant='h6'>{t('equipment', 'Equipment')}</Typography>
        </Grid>
        <Grid size={12}>
          <EquipmentStats currentDate={currentDate} />
        </Grid>
        <Grid size={12}>
          <Typography variant='h6'>{t('cranes', 'Cranes')}</Typography>
        </Grid>
        <Grid size={12}>
          <CraneQueueStats currentDate={currentDate} />
        </Grid>
      </Grid>
    </Box>
  )
})
